import { Entity } from '@backstage/catalog-model';

const decodeBase64 = (encodedStr: string): string => {
  let value: string = '';
  try {
    if (typeof encodedStr !== 'string') {
      return '';
    }
    if (encodedStr) {
      value = Buffer.from(encodedStr, 'base64').toString('utf-8');
    }
    return value;
  } catch (e) {
    return '';
  }
};

export const convertEntityToApplication = (entity: Entity) => {
  return {
    applicationName: entity?.spec?.applicationName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    project: {
      project: entity?.spec?.projectId,
      cluster: entity?.spec?.clusterConfig,
    },
    syncPolicy: entity?.spec?.syncPolicy,
    applicationMetadata: entity?.spec?.applicationMetadata,
  };
};

export const convertEntityToApplicationSet = (entity: Entity) => {
  return {
    applicationSetName: entity?.spec?.applicationSetName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    generators: decodeBase64(String(entity?.spec?.generators || '')),
    project: {
      appNameTemplate: entity?.spec?.appNameTemplate,
      project: entity?.spec?.projectId,
      cluster: entity?.spec?.clusterConfig,
      templatePatch: entity?.spec?.templatePatch
        ? decodeBase64(String(entity?.spec?.templatePatch))
        : null,
    },
    syncPolicy: entity?.spec?.syncPolicy,
    applicationMetadata: entity?.spec?.applicationMetadata,
  };
};

export const convertEntityToProject = (entity: Entity) => {
  return {
    projectName: entity?.spec?.projectName,
    description: entity.metadata.description,
    owner: `group:default/${entity?.spec?.owner}`,
    securityGroups: entity?.spec?.securityGroups,
    clusters: entity?.spec?.clustersRawData,
    notificationChannel: entity?.spec?.notificationChannel || '',
    notificationServices: entity?.spec?.notificationServices,
  };
};
